const AccordionComponentItem = ({ index, question, answer, isFirst }) => {
  const number = index + 1;
  const collapseId = `collapse${number}`;
  const headingId = `heading${number}`;

  return (
    <div className="card">
      <div className="card-header" id={headingId}>
        <button
          className="btn btn-link fontSizeClass m-2"
          data-toggle="collapse"
          data-target={`#${collapseId}`}
          aria-expanded={isFirst}
          aria-controls={collapseId}
        >
          {number}. {question}
        </button>
      </div>
      <div
        id={collapseId}
        // className={`collapse${isFirst ? " show" : ""}`}
        className={`collapse`}
        data-parent="#accordion">
        <div className="card-body m-3 fontSizeClass">{answer}</div>
      </div>
    </div>
  );
};

export const AccordionComponent = ({ list = [] }) => (
  <div id="accordion" className="w-100">
    {list.map((faq, index) => (
      <AccordionComponentItem
        key={faq.question}
        index={index}
        question={faq.question}
        answer={faq.answer}
        isFirst={index === 0}
      />
    ))}
  </div>
);

export default AccordionComponent;
